import { useEffect, useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Loader2, User, Bot } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ChatTranscriptDialog = ({ sessionId, onClose }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!sessionId) return;
    setLoading(true);
    axios.get(`${API}/ai/chat/history/${sessionId}`)
      .then((res) => setMessages(res.data.messages || []))
      .catch((e) => console.error("Transcript load error:", e))
      .finally(() => setLoading(false));
  }, [sessionId]);

  return (
    <Dialog open={!!sessionId} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="chat-transcript-dialog">
        <DialogHeader>
          <DialogTitle>Conversation complète</DialogTitle>
          <DialogDescription className="font-mono text-xs">{sessionId}</DialogDescription>
        </DialogHeader>
        <div className="max-h-[60vh] overflow-y-auto space-y-3 pr-1 bg-slate-50 rounded-xl p-4">
          {loading && <Loader2 className="w-5 h-5 animate-spin mx-auto text-slate-400" />}
          {!loading && messages.length === 0 && <p className="text-sm text-slate-500 text-center">Aucun message</p>}
          {messages.map((m, i) => (
            <div key={m.id || i} className={`flex items-end gap-2 ${m.role === "user" ? "flex-row-reverse" : ""}`} data-testid={`transcript-message-${i}`}>
              <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 ${m.role === "user" ? "bg-slate-200" : "bg-[#102692]"}`}>
                {m.role === "user" ? <User className="w-3.5 h-3.5 text-slate-600" /> : <Bot className="w-3.5 h-3.5 text-white" />}
              </div>
              <div className={`max-w-[78%] rounded-2xl px-3 py-2 text-sm whitespace-pre-wrap ${m.role === "user" ? "bg-[#102692] text-white rounded-br-sm" : "bg-white text-slate-800 shadow-sm rounded-bl-sm"}`}>
                {m.content}
                <div className={`text-[10px] mt-1 ${m.role === "user" ? "text-white/60" : "text-slate-400"}`}>
                  {new Date(m.created_at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
